// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function toString(x) {
  switch (x) {
    case "ASSISTANT" :
      return "Assistant";
    case "ASSOCIATE" :
      return "Associate";
    case "BUYER_SPECIALIST" :
      return "Buyer Specialist";
    case "CLIENT_CARE_COORDINATOR" :
      return "Client Care Coordinator";
    case "INSIDE_SALES_AGENT" :
      return "Inside Sales Agent";
    case "LISTING_MANAGER" :
      return "Listing Manager";
    case "LISTING_SPECIALIST" :
      return "Listing Specialist";
    case "MARKETING_SPECIALIST" :
      return "Marketing Specialist";
    case "OPERATIONS_MANAGER" :
      return "Operations Manager";
    case "OWNER" :
      return "Owner";
    case "PARTNER" :
      return "Partner";
    case "SHOWING_ASSISTANT" :
      return "Showing Assistant";
    case "TRANSACTION_COORDINATOR" :
      return "Transaction Coordinator";
    case "UNKNOWN" :
      return "Unknown";
  }
}

exports.toString = toString;
/* No side effect */
